import { DTOFigmaNodeStructureDetailResponse, DTOFigmaNodeStructureListResponse } from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class FigmaNodeStructuresEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(dsId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/figma-node-structures`,
      DTOFigmaNodeStructureListResponse
    );
  }

  get(dsId: string, structureId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/figma-node-structures/${structureId}`,
      DTOFigmaNodeStructureDetailResponse
    );
  }
}
